module.exports = __webpack_public_path__ + "static/img/NSW-10.e544aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-10.jpg
// module id = lSXd
// module chunks = 0